import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Redirect-Route von /events nach /tickets.
 * Sorgt dafür dass alte Links weiterhin funktionieren.
 */
export const Route = createFileRoute('/events/')({
  beforeLoad: () => {
    throw redirect({ to: '/tickets', replace: true });
  },
  component: () => null,
});
